
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { WorkflowCommonMixin } from "../../../../mixins";
import { ReceptionComment } from "../../../../../../domain/workflow/reception";
import { ReceptionCommentUnitKinds } from "../../../../../../domain/workflow/kinds";
import { ReceptionDateTranslator } from "../../../../../../domain/workflow";

@Component({
})
export default class CommentTableMixin extends Mixins(WorkflowCommonMixin) {
  @Prop()
  mode: ReceptionCommentUnitKinds;

  @Prop()
  comments: ReceptionComment[];

  @Prop({ default: true })
  hasPermission: boolean;

  @Prop()
  detailSelected: boolean;

  @Prop({ default: true })
  isCommentEditable: boolean;

  @Prop({ default: true })
  isCommentDeletable: boolean;

  @Emit()
  add(): void {}

  @Emit()
  edit(row: ReceptionComment): void {}

  @Emit()
  remove(row: ReceptionComment): void {}

  _dateTranslator: ReceptionDateTranslator;

  created(): void {
    this._dateTranslator = new ReceptionDateTranslator();
  }

  isEditable(row: ReceptionComment): boolean {
    return this.mode === ReceptionCommentUnitKinds.Multiple && row.isEditable && this.isCommentEditable;
  }

  isDeletable(row: ReceptionComment): boolean {
    return row.isDeletable && this.isCommentEditable;
  }

  getLastUpdateInformation(row: ReceptionComment): string {
    return row.createUser && row.updateDateTime
      ? "最終更新：" + row.createUser.name + "　" + this._dateTranslator.toDateTimeDispString(row.updateDateTime)
      : "";
  }
}
